import { EditableList } from "@kazaar-platform/design-system";
import { useState } from "react";
import { HighlightIA } from "@/components/OpenBrief/HighlightIA/HighlightIA";
import { type IAEditableFieldProps } from "../BriefSummary.types";

const IAEditableField = ({
  IAValue,
  label,
  children,
  value,
}: IAEditableFieldProps) => {
  const [isEditing, setIsEditing] = useState(false);

  const getValue = () => {
    if (IAValue) {
      return <HighlightIA>{IAValue}</HighlightIA>;
    }

    if (value) {
      return value;
    }

    return undefined;
  };

  return (
    <div className="h-fit w-full">
      <EditableList
        isEditing={isEditing}
        onEdit={setIsEditing}
        value={getValue()}
        title={label}
        isChecked={!!IAValue || !!value}
      >
        {children}
      </EditableList>
    </div>
  );
};

export default IAEditableField;
